import styled, {css} from 'styled-components';

import {mixins} from '../styles';

type TProps = {
  resize?: boolean;
};

export const Textarea = styled.textarea<TProps>`
  ${mixins.input}
  height: auto;
  line-height: 22px;

  ${({resize, theme: {spacing, dimensions}}) => css`
    min-height: ${dimensions.controlHeightM}px;
    padding: ${spacing.s3} ${spacing.s4};
    resize: ${resize ? 'initial' : 'none'};
  `}
`;
